import React from "react";
import { getPlainToken } from "../assets/Js/tokenHandler";
import { callAPI } from "../assets/Js/backendCommunication";
import projectSettings from "../assets/Js/projectSettings";
import { apiResponseToast } from "../assets/Js/apiResponseToast";

export default async function SaveDeviceToken(data) {
  let url = `${projectSettings.baseUrl}/users/savewebtoken`;
  let header = true;
  let type = "POST";
  let token = getPlainToken();
  let response = "";
  response = await callAPI(url, header, type, JSON.stringify(data), token);
  if (response) {
    console.log("Save Device Token:", response);

    if (response.type === "error") {
      console.log("Failed to save device token on server:", response.error);
    } else if (response.type === "success") {
      console.log("Successfully Saved Device Token On Server");
    }
  }
}
